<template>
  <div
    class="client-phone-section"
  >
    <loader
      v-if="loading"
      absolute
    />
    <template v-if="hasActiveCall">
      <div class="call-processing-label">
        <avatar
          class="operator-avatar"
          :user="operator"
        />
        <div class="operator-info">
          <div class="operator-info_top">
            <i></i>Обрабатывает
          </div>
          <div class="operator-info_bottom">
            {{ operatorName }}
          </div>
        </div>
      </div>
    </template>

    <component
      :is="canEmitCallback ? 'button' : 'span'"
      v-else
      class="client-phone d-inline-flex align-center"
      :class="{
        'client-phone-active': order.orderStatus === 'new',
        'theme-transparent': transparent,
        'theme-border-radius-10': borderRadius10,
      }"
      :disabled="loading"
      @click="showCallbackConfirmDialog"
    >
      <font-awesome-icon
        v-if="order.client.phone"
        class="client-phone-icon"
        :class="{nocall: order.basket.noCall }"
        width="19px"
        icon="phone-alt"
      />
      <span class="d-flex flex-column">
        <template v-if="order.client.phone">
          <span class="name">{{ order.client.name }}</span>
          <span class="number font-weight-medium">{{ clientPhone }}</span>
        </template>
        <span
          v-else
          class="name anonim"
        >
          Клиент без регистрации
        </span>
      </span>
    </component>
    <primary-confirm-dialog
      v-if="showCallbackConfirm"
      v-model="showCallbackConfirm"
      title="Выполнить звонок клиенту?"
      confirm-text="Позвонить"
      close-after-loading
      :loading="loading"
      @confirm="emitCallback"
    >
      <template #subtitle>
        <h3 class="d-flex j-center ">
          <span class="text--accent-1">{{ clientPhone }}</span>
          <span class="pr-2 pl-2">-</span>
          <span class="font-weight-medium">{{ order.client.name }}</span>
        </h3>
      </template>
    </primary-confirm-dialog>
    <!--  @confirm="toggleStatus"-->
    <!--  @close="closeStatusDialog"-->
  </div>
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import Loader from '@/components/loader/Loader.vue'
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'

  export default {
    name: 'ClientPhoneBtn',
    components: { PrimaryConfirmDialog, Avatar, Loader },
    mixins: [snackbarMessage],
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
      transparent: {
        type: Boolean,
        default: false,
      },
      borderRadius10: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        loading: false,
        showCallbackConfirm: false,
      }
    },
    computed: {
      canEmitCallback () {
        return this.order.client.phone && this.userCan('crm.callback.create')
      },
      hasActiveCall () {
        return !!this.order?.activeCall
      },
      operator () {
        return this.order?.activeCall?.user || {}
      },
      operatorName () {
        return this.operator?.name
      },
      clientPhone () {
        return this.order?.client?.formattedPhone || this.order?.client?.phone
      },
    },
    methods: {
      showCallbackConfirmDialog () {
        if (!this.canEmitCallback) {
          return false
        }

        this.showCallbackConfirm = true
      },
      async emitCallback () {
        if (this.order.client.phone) {
          this.loading = true
          try {
            await this.$store.dispatch('orders/emitCallback', { id: this.order.id })
            this.showSuccessMessage('Обратный звонок клиенту инициирован')
          } catch (err) {
            this.showErrorFromResponse(err)
          }
          this.loading = false
        }
      },

    },
  }
</script>

<style scoped lang="less">
.client-phone-section {
  button.client-phone {
    cursor: pointer;
    text-align: left;
  }

  span.client-phone {
    cursor: default;
  }
  .client-phone {
    padding: 9px 21px 7px 16px;
    //margin-right: 24px;
    border-radius: 100px;
    text-decoration: none;
    border: 1px solid #000000;
    color: #000000;
    max-width: 200px;
    .fill-svg(#000000);

    &:disabled {
      opacity: 0.7;
    }

    &:not(.theme-transparent) {
      background-color: #ffffff;
    }

    &.theme-border-radius-10 {
      border-radius: 10px;
    }

    &.client-phone-active {
      background-color: @color-primary;
      border: 1px solid @color-primary;
      color: #ffffff;
      .fill-svg(#ffffff);
    }

    .client-phone-icon {
      font-size: 20px;
      &.nocall {
        path {
          fill: #1EE984 !important;
        }
      }
    }

    .name {
      font-size: 11px;
      line-height: 1.2;
      .media-xl({
        font-size: 14px;
        line-height: 17px;
      });
    }

    .number {
      font-size: 11px;
      line-height: 1.2;
      white-space: nowrap;

      @media (min-width: @md) {
        font-size: 12px;
      }

      .media-xl({
        font-size: 16px;
        line-height: 19px;
      });
    }

    svg {
      width: 17px;
      margin-right: 12px;
    }
  }

  .call-processing-label {
    z-index: 300;
    position: relative;
    display: flex;
    align-items: center;

    .operator-avatar {
      margin-right: 7px;
      .media-xl({
        margin-right: 14px;
      })
    }

    .operator-info {
      line-height: 1.25;

      &_top {
        font-size: 11px;
        i {
          display: inline-block;
          background: #1EE984;
          width: 5px;
          height: 5px;
          margin-right: 4px;
          border-radius: 50%;
        }
        .media-xl({
          font-size: 14px;
          i {
            width: 8px;
            height: 8px;
            margin-right: 7px;
          }
        })
      }
      &_bottom {
        //text-align: right;
        font-weight: 500;
        font-size: 13px;
        .media-xl({
          font-size: 16px;
        })
      }
    }
  }

}

</style>
